import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';
export class PropertyChange<T> {
  private readonly source: BehaviorSubject<T>;

  public get value(): T {
    return this.source.value;
  }

  public get valueChanges(): Observable<T> {
    return this.source.asObservable();
  }
  public setValue(value?: T): void {
    this.source.next(value);
  }

  constructor(value?: T) {
    this.source = new BehaviorSubject(value);
  }
}

@Injectable()
export class StoredPropertyChange<T> extends PropertyChange<T> {
  constructor(
    private readonly storeService: LocalStorageService,
    private readonly key: string,
    value?: T,
  ) {
    super(value ?? storeService.get<T>(key));
  }

  public setValue(value?: T): void {
    this.storeService.set(this.key, value);
    super.setValue(value);
  }

  public removeValue(): void {
    this.storeService.remove(this.key);
  }
}
